import React from "react";
import styled from "styled-components";
import fipayFonts from "../../theme/index";
import Navbar from "../Navbar/Navbar";

interface SecurityHeroProps {}

const images = [
  {
    imgPath: "/assets/icons/security.svg",
  },
];

const SecurityHero: React.FC<SecurityHeroProps> = () => {
  return (
    <SecurityContainer>
      <Navbar />
      <HeroContainer>
        <HeroContent>
          <HeroTitle>
            {"Protecting you and"}
            <br />
            {"your money"}
          </HeroTitle>
          <HeroParagraph>
            {`The next level of payment security. Our AI-powered platform safeguards your data with cutting-edge technology and adheres to the highest PCI & PCI DSS standards.`}
          </HeroParagraph>
        </HeroContent>

        <SecurityImage src={images[0].imgPath} alt="Security" />
      </HeroContainer>
    </SecurityContainer>
  );
};

const SecurityContainer = styled.section`
  background-image: url("/assets/icons/LandingPage.jpg");
  display: flex;
  align-items: center;
  background-size: cover;
  flex-direction: column;

  @media (max-width: 768px) {
    max-height: 80%;
  }
`;

const HeroContainer = styled.div`
  width: 90%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin: 0;
  padding-top: 40px;
  padding-bottom: 120px;

  @media (max-width: 768px) {
    flex-direction: column;
    align-items: center;
    padding-bottom: 20px;
    gap: 0.2px;
  }
`;

const HeroContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  max-width: 50%;

  @media (max-width: 768px) {
    max-width: 100%;
  }
`;

const SecurityImage = styled.img`
  width: 50%;
  max-height: 450px;
  object-fit: cover;
  align-self: flex-start;
  margin-top: 20px;
  margin-right: 35px;

  @media (max-width: 768px) {
    width: 110%;
    margin-top: 15px;
    margin-bottom: 0.009px;
  }
`;

const HeroTitle = styled.div`
  width: 700px;
  font-family: GT Walsheim Pro;
  color: #09005b;
  font-size: 55px;
  font-weight: 700;
  line-height: 64px;
  ${fipayFonts.fipayFonts.heading1};
  padding-top: 7rem;

  @media (max-width: 768px) {
    padding-top: 1rem;
    font-size: 30px;
    text-align: left;
    width: 100%;
    line-height: 34.35px;
  }
`;

const HeroParagraph = styled.p`
  font-family: GT Walsheim Pro;
  font-size: 15px;
  font-weight: 400;
  letter-spacing: 2%;
  color: #5e5e5e;
  line-height: 32px;
  width: 550px;
  margin-bottom: 32px;

  @media (max-width: 768px) {
    width: 100%;
    text-align: left;
    margin-bottom: 10px;
    font-weight: 400;
    line-height: 24px;
  }
`;

export default SecurityHero;
